import { useSearchParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, MapPin, Calendar, Clock, ArrowLeft } from "lucide-react";
import { TEST_IDS } from "@/constants/testIds";

export default function ThankYouPage() {
  const [params] = useSearchParams();
  const ref = params.get("ref") || "—";
  const name = params.get("name") || "";
  const location = params.get("location") || "";
  const date = params.get("date") || "";
  const time = params.get("time") || "";

  return (
    <div data-testid={TEST_IDS.thankYouPage} className="min-h-screen bg-[#0d0b09] flex items-center justify-center px-4 py-12">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }} className="w-full max-w-lg">
        <div className="bg-[#17120e] border border-[rgba(242,207,139,0.18)] rounded-2xl p-8 sm:p-10 text-center shadow-[0_24px_80px_rgba(0,0,0,0.45)]">
          <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.3, type: "spring", stiffness: 200, damping: 15 }}
            className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#39c47a]/10 flex items-center justify-center">
            <CheckCircle className="w-10 h-10 text-[#39c47a]" />
          </motion.div>

          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#f2cf8b] mb-3">Booking Request Received</p>
          <h1 className="font-serif text-3xl sm:text-4xl font-semibold text-[#f8f0df] mb-4">Your Couple Reset<br/>is in motion.</h1>
          <p className="text-[#bdb3a4] leading-relaxed mb-6">
            Your ₹5 verification payment has been received. Epsom's team will contact you on WhatsApp to confirm the location, date and available time slot.
          </p>

          <div className="bg-[#0e0c0a] rounded-xl p-5 mb-6 text-left space-y-3 border border-[#3a3026]">
            {name && <div className="flex items-center gap-3 text-sm text-[#ded4c4]"><span className="font-semibold text-[#f8f0df]">Name:</span> {name}</div>}
            {location && <div className="flex items-center gap-3 text-sm text-[#ded4c4]"><MapPin className="w-4 h-4 text-[#d7a85c] shrink-0" />{location}</div>}
            {date && <div className="flex items-center gap-3 text-sm text-[#ded4c4]"><Calendar className="w-4 h-4 text-[#d7a85c] shrink-0" />{date}</div>}
            {time && <div className="flex items-center gap-3 text-sm text-[#ded4c4]"><Clock className="w-4 h-4 text-[#d7a85c] shrink-0" />{time}</div>}
          </div>

          <div data-testid={TEST_IDS.bookingReference} className="inline-block bg-[#d7a85c]/10 border border-[#d7a85c]/20 rounded-lg px-4 py-2 mb-6">
            <span className="text-xs text-[#bdb3a4] block">Booking Reference</span>
            <span className="font-mono text-lg font-bold text-[#f2cf8b]">{ref}</span>
          </div>

          <p className="text-xs text-[#9f968a] mb-6"><strong className="text-[#bdb3a4]">Important:</strong> Your requested slot is not confirmed until Epsom confirms availability.</p>

          <div className="flex flex-col sm:flex-row gap-3">
            <Link to="/" className="flex-1 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl border border-[rgba(242,207,139,0.18)] text-[#bdb3a4] font-semibold text-sm hover:bg-[#211a14] transition-colors">
              <ArrowLeft className="w-4 h-4" /> Back to Home
            </Link>
            <a href="https://www.epsomcryospa.com/" target="_blank" rel="noopener noreferrer"
              className="flex-1 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-gradient-to-r from-[#f1cb82] to-[#b77a31] text-[#1b1108] font-bold text-sm shadow-lg shadow-[#d7a85c]/18 hover:shadow-xl transition-all">
              Visit Epsom Website
            </a>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
